__turbopack_context__.v({
  "buttonContainer": "GenericButton-module__3PDYGG__buttonContainer",
});
